import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import BankAccountFactory from "../../Entity/Factories/BankAccountFactory";
import { BankAccountInterface } from "../../Entity/Entities/BankAccount/BankAccountInterface";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

function* revokePontoAccess(action: ActionInterface): any {
  try {
    const res = yield call(Http.post, `bankAccount/ponto-logout`);

    const bankAccount: BankAccountInterface = BankAccountFactory.create(res.data);

    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_UPDATE_SUCCESS,
      payload: {
        bankAccount: bankAccount
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, bankAccount);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}


function* synchronizeWithPonto(action: ActionInterface) {
  try {
    const { bankAccountId } = action.payload;
    const res = yield call(Http.post, `bankAccount/${bankAccountId}/synchronize`);
    const bankAccount: BankAccountInterface = BankAccountFactory.create(res.data);

    yield put({
      type: Constants.PONTO_SYNCHRONIZATION_BUTTON_DISABLED,
      payload: false
    });

    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_UPDATE_SUCCESS,
      payload: {
        bankAccount
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, bankAccount);
    }

  } catch (err) {
    yield put({
      type: Constants.PONTO_SYNCHRONIZATION_BUTTON_DISABLED,
      payload: false
    });
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPonto() {
  yield takeEvery(Constants.GLOBAL_PONTO_REVOKE_ACCESS, revokePontoAccess);
  yield takeEvery(Constants.GLOBAL_PONTO_SYNCHRONIZE, synchronizeWithPonto);
}